export default "__VITE_ASSET__D_61rtZ7__"